export default "__VITE_ASSET__D7bC4BFE__"